import { useEffect, useState } from 'react';
import { useGamesStore } from '../stores/gamesStore';
import { AnalyticsTab } from './games/AnalyticsTab';
import { SessionsTab } from './games/SessionsTab';
import { RewardsTab } from './games/RewardsTab';

// Аналитика идёт первой: её открывают чаще всего, чтобы понять,
// что происходит с играми вообще.
const TABS = [
  { id: 'analytics', label: 'Аналитика' },
  { id: 'sessions', label: 'Партии' },
  { id: 'rewards', label: 'Награды' },
];

export const Games = () => {
  const { games, error, success, clearError, clearSuccess } = useGamesStore();
  const [tab, setTab] = useState('analytics');

  // Список игр нужен «Партиям» для фильтра и «Наградам» для карточек.
  useEffect(() => {
    useGamesStore.getState().fetchGames();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-text-primary">Игры</h1>
        <p className="text-sm text-text-secondary mt-1">
          Аналитика по играм, журнал сыгранных партий и настройка наград за достижения.
        </p>
      </div>

      <div className="flex gap-1 border-b border-border-color">
        {TABS.map((item) => (
          <button
            key={item.id}
            onClick={() => setTab(item.id)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
              tab === item.id
                ? 'border-accent-primary text-accent-primary'
                : 'border-transparent text-text-secondary hover:text-text-primary'
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>

      {error && (
        <div
          onClick={clearError}
          className="bg-red-500/10 border border-red-500/30 text-red-300 rounded-xl px-4 py-3 cursor-pointer"
        >
          {error}
        </div>
      )}

      {success && (
        <div
          onClick={clearSuccess}
          className="bg-green-500/10 border border-green-500/30 text-green-300 rounded-xl px-4 py-3 cursor-pointer"
        >
          {success}
        </div>
      )}

      {tab === 'analytics' && <AnalyticsTab />}
      {tab === 'sessions' && <SessionsTab games={games} />}
      {tab === 'rewards' && <RewardsTab />}
    </div>
  );
};